import Home from "../../../components/Home/Home";
import {sidebarItems} from "../../../utils/sidebarItems";

const SysadminHome = () => {
    return (
        <Home navigationItems={sidebarItems.sysadmin}/>
    )
}

export default SysadminHome;